export default () => ({
    isLoading: false,
});
